/**
 * 実行環境関連 Class
 */
export default class Environment {
  /**
   * デバイスタイプ判定
   * @returns {string}
   */
  static getDeviceType() {
    let deviceType = 'pc';
    let windowW = window.outerWidth;
    if (750 >= windowW) {
      deviceType = 'sp'
    }
    return deviceType
  };

  /**
   * ヘッダー高さ取得
   * @returns {number}
   */
  static getHeaderH() {
    let headerH = $('.l-header').outerHeight();
    return headerH;
  };
}
